// import { useState } from "react";
// import { toast } from "react-toastify";
// import { createProject } from "../../apis/projectApi";

// export const useAddProject = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(false);

//   const addProject = async (formData) => {
//     setLoading(true);
//     setError(null);
//     setSuccess(false);

//     const toastId = toast.loading("Creating new project...");

//     try {
//       const data = await createProject(formData);

//       toast.update(toastId, {
//         render: "Project created successfully!",
//         type: "success",
//         isLoading: false,
//         autoClose: 3000,
//       });

//       setSuccess(true);
//       return data;
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to create project. Please check the form data.";

//       toast.update(toastId, {
//         render: errorMessage,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });

//       setError(errorMessage);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   return {
//     addProject,
//     loading,
//     error,
//     success,
//   };
// };

import { useState } from "react";
import { toast } from "react-toastify";
import { createProject } from "../../apis/projectApi";

export const useAddProject = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
const extractError = (err) => {
      // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
          "Failed to create project. Please try again.",
      };
    };

  const addProject = async (formData) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    const toastId = toast.loading("Creating new project...");

    try {
      const response = await createProject(formData);

      toast.update(toastId, {
        render: (
          <div>
            <strong>Project Created</strong>
            <div>Project created successfully!</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      setSuccess(true);
      return response.data; // assuming axios response
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError({ title, issue });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    addProject,
    loading,
    error,
    success,
  };
};